<div class="sidenav-content" @routeAnimation>
	<div class="claim-dashboard-container">
		<div class="claim-dashboard-nav">

			<div class="claim-dashboard-nav-header">
				<copo-back-button></copo-back-button>
				<span translate>product.quality.dashboard</span>
			</div>
		</div>

		<div class="claim-dashboard-content">
			<div class="claim-dashboard-content-widgets">
				<copo-quality-feedback-card *ngIf="hasIssueService()"></copo-quality-feedback-card>
				<copo-last-guarantee-requests-widget *ngIf="hasGuaranteeService()"></copo-last-guarantee-requests-widget>
			</div>
		</div>
	</div>
</div>
